import Vue from "vue";
import Vuex from "vuex";
import { WebSale } from '@/apps/shared/models/webSale';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        webSale: null as WebSale | null,
    },
    mutations: {
        setWebSaleData(state, webSale: WebSale | null) {
            state.webSale = webSale === null ? null : { ...webSale };
        },
    },
    actions: {
        updateWebSaleData({ commit }, webSale: WebSale | null) {
            commit('setWebSaleData', webSale);
        },
    },
    getters: {
        getWebSaleData(state) {
            return state.webSale;
        },
    },
});